import React from 'react'
import PropTypes from 'prop-types'
import { maxSavingsText } from '../../util/get-qualified-flex-dates'
import FlexResponsiveContainer from './FlexResponsiveContainer'
import { Box, Text } from 'pcln-design-system'
import { FlexDatesWrapper, FlexDatesContainer, DatesBanner } from './FlexDatesRoundTrip.styles'

function FlexDatesRoundTrip(props) {
  const {
    minimumRetailPrice,
    qualifiedFlexDates,
    shouldShowMaxSavings,
    flyGaLogic,
    searchOrigin,
    searchDestination,
    isDesktop,
  } = props

  const savingsText = maxSavingsText(qualifiedFlexDates, minimumRetailPrice, shouldShowMaxSavings)
  const isSlimDesign = qualifiedFlexDates.length === 3

  return (
    <FlexDatesWrapper data-test='flex-dates-wrapper' m={([0, 0, '20px 4px 20px 4px'], '20px 30px 20px 24px')}>
      {isSlimDesign ? (
        <Box mb={2}>
          <Text
            pb={2}
            ml={['16px', '14px', '14px', '14px', 0]}
            bold
            fontSize={['14px', '14px', '14px', '14px', '16px']}
          >
            Find the best day to travel
          </Text>
          <FlexResponsiveContainer
            data-test='flex-dates-container'
            data-testid='flex-dates-container'
            dates={qualifiedFlexDates}
            minimumRetailPrice={minimumRetailPrice}
            flyGaLogic={flyGaLogic}
            searchOrigin={searchOrigin}
            searchDestination={searchDestination}
            isDesktop={isDesktop}
            isSlimDesign={isSlimDesign}
            borderRadius='xl'
          />
        </Box>
      ) : (
        <FlexDatesContainer borderRadius='xl'>
          <DatesBanner
            data-test='flex-dates-saveMax'
            bg='primary.base'
            showIcon={false}
            borderRadius='lg'
            rounded='top'
          >
            {savingsText}
          </DatesBanner>
          <FlexResponsiveContainer
            data-test='flex-dates-container'
            data-testid='flex-dates-container'
            dates={qualifiedFlexDates}
            minimumRetailPrice={minimumRetailPrice}
            flyGaLogic={flyGaLogic}
            searchOrigin={searchOrigin}
            searchDestination={searchDestination}
            isDesktop={isDesktop}
            isSlimDesign={isSlimDesign}
            borderRadius='lg'
            rounded='bottom'
          />
        </FlexDatesContainer>
      )}
    </FlexDatesWrapper>
  )
}

export default FlexDatesRoundTrip

FlexDatesRoundTrip.defaultProps = {
  isInline: false,
}

FlexDatesRoundTrip.propTypes = {
  minimumRetailPrice: PropTypes.number,
  flyGaLogic: PropTypes.object,
  qualifiedFlexDates: PropTypes.arrayOf(
    PropTypes.shape({
      fare: PropTypes.number,
      departDate: PropTypes.string,
      returnDate: PropTypes.string,
    })
  ),
  shouldShowMaxSavings: PropTypes.bool,
  searchOrigin: PropTypes.string,
  searchDestination: PropTypes.string,
  isDesktop: PropTypes.bool,
}
